import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background paper-texture grid place-items-center p-6">
      <div className="max-w-md w-full text-center bg-card border border-border rounded-md p-10" data-testid="payment-cancel-page">
        <XCircle size={56} className="mx-auto text-muted-foreground mb-4" />
        <div className="label-caps mb-2">Checkout cancelled</div>
        <h1 className="font-serif text-4xl mb-3">No harm done.</h1>
        <p className="text-muted-foreground mb-6">You weren't charged. When you're ready, come back and pick your plan.</p>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => nav("/dashboard")} className="flex-1" data-testid="cancel-back-dashboard">Dashboard</Button>
          <Button onClick={() => nav("/pricing")} className="flex-1" data-testid="cancel-back-pricing">Back to plans</Button>
        </div>
        <Link to="/pricing" className="hidden">plans</Link>
      </div>
    </div>
  );
}
